@import (reference) '../../constants/spacing.module.less';

.grid-container {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: @space-12;

  background-color: var(--new-grey-100);
  border: 1px solid var(--new-grey-300);
  border-radius: 4px;
}

.dangerous-goods-amount {
  display: flex;
  gap: @space-8;
  align-items: center;
  button {
    height: 32px;
  }

  .amount-unit {
    width: 100px;
  }
}

.packaging-group {
  button {
    height: 32px;
  }
}
